import { trpc } from '@/shared/api';
import { useLandingHeroUpload } from './use-landing-hero-upload';

interface UseAddLandingHeroImageOptions {
  readonly onSuccess?: () => void;
}

/** 파일을 올리고 목록 맨 뒤에 등록한다. */
export const useAddLandingHeroImage = ({ onSuccess }: UseAddLandingHeroImageOptions = {}) => {
  const uploader = useLandingHeroUpload();
  const mutation = trpc.landing.createHeroImage.useMutation({ onSuccess });

  const addImage = async (file: File): Promise<void> => {
    const imageKey = await uploader.upload(file);

    if (imageKey !== null) {
      mutation.mutate({ imageKey });
    }
  };

  return {
    addImage,
    isPending: uploader.isUploading || mutation.isPending,
    error: uploader.error ?? mutation.error?.message ?? null,
    /** 지난 업로드·서버 오류를 지운다 — 관리 화면의 다른 요청을 시작할 때 옛 오류가 남지 않게. */
    reset: () => {
      mutation.reset();
      uploader.clearError();
    },
  };
};
